import {Component} from '@angular/core';
import {environment} from 'src/environments/environment';
import * as moment from 'moment-timezone';
import {DEFAULT_TIMEZONE} from '../../i18n/i18n-defaults';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    get copyright(): string {
        let tz;
        try {
            tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            tz = DEFAULT_TIMEZONE;
        }
        return (environment.copyright as string).replace('$YEAR$', moment.tz(tz).year().toString());
    }

    get address(): string {
        return environment.address as string;
    }
}
